import {
  VISCOSITY_DEFAULTS,
  VISCOSITY_QUERY_KEYS,
  VISCOSITY_UNIT_LABELS,
  VISCOSITY_UNIT_OPTIONS,
  ViscosityDisplayUnit,
} from "./definitions";

export { VISCOSITY_QUERY_KEYS };

const clampSpecificGravity = (sg?: number | null) => {
  if (!sg || !Number.isFinite(sg) || sg <= 0) {
    return 1;
  }

  return sg;
};

export const normalizeViscosityUnit = (
  unit?: string | null | undefined
): ViscosityDisplayUnit => {
  if (unit && VISCOSITY_UNIT_OPTIONS.includes(unit as ViscosityDisplayUnit)) {
    return unit as ViscosityDisplayUnit;
  }

  return VISCOSITY_DEFAULTS.unit;
};

export const getViscosityUnitLabel = (unit: ViscosityDisplayUnit) =>
  VISCOSITY_UNIT_LABELS[unit];

export const convertViscosityToCanonical = (
  value?: number | null,
  unit?: string | null,
  sg?: number | null
) => {
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return undefined;
  }

  const finalUnit = normalizeViscosityUnit(unit);
  const finalSg = clampSpecificGravity(sg);

  switch (finalUnit) {
    case "cSt":
      return value;
    case "cP":
    case "mPa·s":
      return value / finalSg;
    case "Pa·s":
      return (value * 1000) / finalSg;
    default:
      return value;
  }
};

export const convertViscosityFromCanonical = (
  value?: number | null,
  unit?: string | null,
  sg?: number | null
) => {
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return undefined;
  }

  const finalUnit = normalizeViscosityUnit(unit);
  const finalSg = clampSpecificGravity(sg);

  switch (finalUnit) {
    case "cSt":
      return value;
    case "cP":
    case "mPa·s":
      return value * finalSg;
    case "Pa·s":
      return (value * finalSg) / 1000;
    default:
      return value;
  }
};

export const normalizeViscosityInput = (
  rawValue?: number | string | null,
  rawUnit?: string | null,
  sg?: number | null
) => {
  if (rawValue === "" || rawValue === null || rawValue === undefined) {
    return undefined;
  }

  const numericValue = Number(rawValue);
  if (!Number.isFinite(numericValue) || numericValue <= 0) {
    return undefined;
  }

  return convertViscosityToCanonical(numericValue, rawUnit, sg);
};
